module.exports = __webpack_public_path__ + "img/login_banner.1c9f8bb2.png";